import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { palette } from '../../styles/tokens';
import type { RevenueDataPoint } from '../../types';

interface RevenueChartProps {
  data: RevenueDataPoint[];
}

export function RevenueChart({ data }: RevenueChartProps) {
  if (data.length === 0) {
    return (
      <div style={{ padding: '20px 0', textAlign: 'center', color: palette.g400, fontSize: 13.5 }}>
        No revenue data this week.
      </div>
    );
  }

  const hasData = data.some(d => d.value > 0);

  if (!hasData) {
    return (
      <div style={{ padding: '20px 0', textAlign: 'center', color: palette.g400, fontSize: 13.5 }}>
        No paid invoices this week yet.
      </div>
    );
  }

  // Determine which days have passed (have data or are before today)
  const todayIndex = new Date().getDay();
  // Mon=0 in our chart, but getDay: Mon=1, Sun=0
  const adjustedToday = todayIndex === 0 ? 6 : todayIndex - 1;

  return (
    <div style={{ marginTop: 16 }}>
      <ResponsiveContainer width="100%" height={130}>
        <BarChart data={data} barCategoryGap="20%">
          <XAxis
            dataKey="label"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 10.5, fill: palette.g400, fontWeight: 500 }}
          />
          <YAxis hide />
          <Tooltip
            formatter={(value) => [`$${value}`, 'Revenue']}
            contentStyle={{
              border: `1px solid ${palette.g150}`,
              borderRadius: 8,
              fontSize: 12,
              boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            }}
          />
          <Bar dataKey="value" radius={[3, 3, 0, 0]} maxBarSize={40}>
            {data.map((_entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={index <= adjustedToday ? palette.accent : palette.g200}
                opacity={data[index].value === 0 ? 0.3 : 1}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
